import { Box } from '@mui/material';

import PageLayout from 'components/PageLayoutComponent';
import { ReactNode } from 'react';

interface BasicLayoutProps {
  children: ReactNode;
}

function BasicLayout({ children }: BasicLayoutProps) {
  return (
    <PageLayout>
      <Box
        width="100%"
        height="100%"
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        zIndex={1000}
      >
        {children}
      </Box>
      {/* <Footer light={true} /> */}
    </PageLayout>
  );
}

export default BasicLayout;
